import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaSylwestra = () => (
  <SeoPageLayout title="Kabaret na sylwestra - powitaj Nowy Rok ze śmiechem">
    <p>
      Sylwester firmowy to wyjątkowa okazja, by podziękować zespołowi za cały rok ciężkiej pracy. Kabaret na sylwestra to doskonała atrakcja, która wypełni czas oczekiwania na północ humorem i doskonałą zabawą.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Sylwester firmowy z kabaretem</h2>
    <p>
      Na imprezach sylwestrowych kabaret pełni szczególną rolę - buduje atmosferę zabawy i oczekiwania na Nowy Rok. Występ może stanowić główną atrakcję wieczoru lub być częścią większego programu z muzyką i tańcami.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Program sylwestrowy</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Występ kabaretowy - 45-90 minut profesjonalnego humoru</li>
      <li>Humorystyczne podsumowanie roku - przegląd firmowych wydarzeń</li>
      <li>Odliczanie do północy - kabaret prowadzi do kulminacji wieczoru</li>
      <li>Noworoczne postanowienia - komediowa wersja firmowych celów</li>
      <li>Prowadzenie imprezy - konferansjer przez cały wieczór</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Dlaczego kabaret na sylwestra?</h2>
    <p>
      Sylwester to czas radości i świętowania. Kabaret dodaje wieczorowi energii, śmiechu i wspólnych wspomnień. To inwestycja w relacje w zespole, która procentuje przez cały nadchodzący rok.
    </p>
  </SeoPageLayout>
);

export default KabaretNaSylwestra;
